import React from 'react';
import styles from './FormSubmitButton.module.scss';
import classNames from 'classnames';

interface IFormSubmitButton {
    label: string;
    isSubmitButtonDisabled?: boolean;
    omitSubmitButtonMargin?: boolean;
}

export const FormSubmitButton: React.FC<IFormSubmitButton> = ({
    label,
    omitSubmitButtonMargin,
    isSubmitButtonDisabled,
}) => (
    <button
        className={classNames(styles.submitButton, {
            [styles.submitButtonWithoutMargin]: omitSubmitButtonMargin,
        })}
        disabled={isSubmitButtonDisabled}
        type={'submit'}>
        {label}
    </button>
);
